//---------	Global imports
import React from 'react';
import Link from 'gatsby-link';

//---------  Plugins
import { onTemplateLoad } from '../Components/Shared/Commons'

//---------	Translations
import { T } from '../../translations';

//---------	Components
import SEO from '../components/SEO/index';
import Newsletter from '../components/Newsletter/index';


class ContentTemplate extends React.Component {

  //---------	Constructor
  constructor(){
    super();
    
    this.state = {
      loading: true
    };
  }

  //---------	React functions
  componentDidMount() {
    setTimeout(() => this.setState({loading: false}), 300);
    setTimeout(() => onTemplateLoad());
  }
  
  render() {
    const data = this.props.data.markdownRemark.frontmatter;
    const seo = {
      title: `${data.title} | Calipsy`
    };
    
    return (
      <div className={this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper'}>
  
        <SEO {...seo}/>
  
        <div className="CalipsySpinner"></div>
        <div className="CalipsyWrapper-container">
          
          <div dangerouslySetInnerHTML={{__html: this.props.data.markdownRemark.html}}></div>
  
          { data.newsletter ? <Newsletter alternateContent={true}/> : null }
          
        </div>
      </div>
    );
  }
}
export default ContentTemplate;

export const pageQuery = graphql`
  query ContentTemplate($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
        newsletter
        banner {
          imageUrl
          type
          anchor
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/content.js